import Store from '@stores/store';

export default config => new Store(config);
